__turbopack_context__.v({
  "interactive-link": "-jrXRW_interactive-link",
  "interactive-link--caption": "-jrXRW_interactive-link--caption",
  "interactive-link--dark": "-jrXRW_interactive-link--dark",
  "interactive-link--md": "-jrXRW_interactive-link--md",
  "interactive-link--narrow": "-jrXRW_interactive-link--narrow",
  "interactive-link--primary": "-jrXRW_interactive-link--primary",
  "interactive-link--secondary": "-jrXRW_interactive-link--secondary",
  "interactive-link--sm": "-jrXRW_interactive-link--sm",
  "interactive-link__icon": "-jrXRW_interactive-link__icon",
  "interactive-link__icon--end": "-jrXRW_interactive-link__icon--end",
  "interactive-link__icon--start": "-jrXRW_interactive-link__icon--start",
});
